export default "__VITE_ASSET__cb7adfa0__"